import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=0dc5dace&scoped=true&"
import script from "./Terminal.vue?vue&type=script&lang=js&"
export * from "./Terminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc5dace",
  null
  
)

export default component.exports